import { ref, watch, computed } from '@vue/composition-api'
import {requestsUseCase} from '../../usecases'
import { setAsSeen } from '../../services/requests.service'
import useStore from '../useStore'
import useRouter from '../useRouter'
import {dashboardUtils} from '../../utils'
import moment from 'moment'
const useRequests = () => {
    const requests = ref([])
    const loading = ref(false)
    const totalCount = ref(0)
    const {store} = useStore()
    const {route, router} = useRouter()

    const setRequests = async (requestId) => {

        const page = route.value.query.page - 1 || dashboardUtils.DEFUALT_PAGE;
        const perPage = route.value.query.perPage || dashboardUtils.DEFAULT_PER_PAGE;
        loading.value = true;

        const sortBy = route.value.query.sortBy || 'DESC'

        try {
            const res = await requestsUseCase.getRequestsList(page, perPage, {must: must.value}, sortBy)
            if(!res) return
            requests.value = res.requests;
            totalCount.value = res.totalCount

            // mark requests as seen
            const IDs = res.requests.filter(item => item.seen === false).map(x => x.id)
            setAsSeen(IDs)
        } catch(err) {
            console.log(err)
        } finally {
            loading.value = false;
        }
    }
    
    const must = computed(() => {

        const mustParams = [];

        let requestUserKey = route.value.query.type === 'sent' ? "sender.uid" : 'receiver.uid'
        
        mustParams.push({
            term: {
                [requestUserKey]: store.state.user.uid
            }
        })


        if(route.value.query.id){
            mustParams.push({
                term: {
                    _id: route.value.query.id
                }
            })
            return mustParams
        }
        
        const filters = route.value.query.filters ? JSON.parse(route.value.query.filters) : {}

        if(filters.myCampaign){

            if(route.value.query.type === 'sent') {
                mustParams.push({
                    term: {
                        'sender.campaign': filters.myCampaign
                    }
                })
            } else {
                mustParams.push({
                    term: {
                        'receiver.campaign': filters.myCampaign
                    }
                })
            }
            
        }

        if(filters.partnerCampaign) {
            if(route.value.query.type === 'sent') {
                mustParams.push({
                    term: {
                        'receiver.campaign': filters.partnerCampaign
                    }
                })
            } else {
                mustParams.push({
                    term: {
                        'sender.campaign': filters.partnerCampaign
                    }
                })
            }
        }

        if(filters.status) {
            mustParams.push({
                term: {
                    'status': filters.status === 'confirmed' ? 'accepted' : filters.status
                }
            })
        }

        if(filters.dateRange) {
            mustParams.push({
                constant_score: {
                    filter: {
                       bool: {
                            must:[{
                                range: {
                                    "receiver.update_date._seconds": {
                                        gte: moment.utc(filters.dateRange[0]).valueOf() / 1000,
                                        lte: moment.utc(filters.dateRange[1]).valueOf() / 1000,
                                    },
                                    
                                },
                            },
                            {
                                range: {
                                    "sender.update_date._seconds": {
                                        gte: moment.utc(filters.dateRange[0]).valueOf() / 1000,
                                        lte: moment.utc(filters.dateRange[1]).valueOf() / 1000,
                                    }
                                }
                            }
                        ]
                        }
                    },
                }
            })
        }

        return mustParams
    })


    const setRequestData = (id, {key, value}) => {
        requests.value = requests.value.map(item => {
            if(item.id === id) {
                item[key] = value;
            }
            return item;
        })
    }

    watch(route, (newRoute, oldRoute) => {

        // prevent requests loading for counterOffer param
        if(oldRoute) {
            const newRouteQueryParams = Object.keys(newRoute.query)
            const oldRouteQueryParams = Object.keys(oldRoute.query)
            if(newRouteQueryParams.includes('counterOffer') || oldRouteQueryParams.includes('counterOffer')){
                return;
            }

            if(oldRoute.query.filters !== newRoute.query.filters){
                if(newRoute.query.page) {
                    router.replace({
                        query: {
                            ...newRoute.query,
                            page: undefined
                        }
                    })
                    return
                } 
            }

        }

        setRequests()
        
    }, {immediate: true})


    return {
        loading,
        totalCount,
        setRequestData,
        requests
    }

}

export default useRequests
